import { Box } from '@mui/material';
import { useState } from 'react';
import { SketchPicker } from 'react-color';

interface SketcherProps {
  hexadecimal: string;
  setHexadecimal: (hex: string) => void;
  setIsSkecthOpen: (isOpen: boolean) => void;
  onPickColor: (color: string) => void;
}

function Sketcher({
  hexadecimal,
  setHexadecimal,
  setIsSkecthOpen,
  onPickColor,
}: SketcherProps) {
  const [tempHexadecimal, setTempHexadecimal] = useState<string>(hexadecimal);

  const handleSave = () => {
    setHexadecimal(tempHexadecimal);
    onPickColor(tempHexadecimal);
    setIsSkecthOpen(false);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#fff',
          padding: 2,
          borderRadius: '8px',
          boxShadow: 3,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 1,
          }}
        >
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setIsSkecthOpen(false)}
          >
            キャンセル
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
          >
            保存
          </button>
        </Box>

        <SketchPicker
          color={tempHexadecimal}
          onChange={(color) => setTempHexadecimal(color.hex)}
          width="250px"
          disableAlpha
        />
      </Box>
    </Box>
  );
}

export default Sketcher;
